// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"c744dd5a","340":"e0755db9","505":"56e0d21e","745":"9089406d"}[chunkId] + ".css";
};